import { render, staticRenderFns } from "./MessageCategories.vue?vue&type=template&id=6df61c82&"
import script from "./MessageCategories.vue?vue&type=script&lang=ts&"
export * from "./MessageCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports